import React, { useState } from "react";

const C=["#2563EB","#F97316","#16A34A","#92400E","#6B7280","#d0d0d0","#DC2626","#aaaaaa","#CA8A04","#7C3AED","#DB2777","#0891B2"];
const N=["Azul","Naranja","Verde","Marron","Gris","Blanco","Rojo","Negro","Amarillo","Violeta","Rosado","Aqua"];
const FIB_BG   =["rgba(37,99,235,0.07)","rgba(22,163,74,0.07)","rgba(220,38,38,0.07)","rgba(124,58,237,0.07)","rgba(202,138,4,0.07)","rgba(8,145,178,0.07)","rgba(219,39,119,0.07)","rgba(107,114,128,0.07)"];
const FIB_COLOR=["#2563EB","#16A34A","#DC2626","#7C3AED","#CA8A04","#0891B2","#DB2777","#6B7280"];

function cH(b,h){return C[(parseInt(h)-1)%12];}
function nH(b,h){return N[(parseInt(h)-1)%12];}
function cBuf(b){return C[(parseInt(b)-1)%12];}
function nBuf(b){return N[(parseInt(b)-1)%12];}
function absH(b,h){return(parseInt(b)-1)*12+parseInt(h);}

function Dot({color,sz=7}){
  return <div style={{width:sz,height:sz,borderRadius:"50%",background:color,flexShrink:0,border:"1px solid rgba(255,255,255,0.1)"}}/>;
}
function FMark({c1,c2}){
  return(
    <div style={{display:"flex",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{width:8,height:2,background:c1}}/>
      <div style={{width:6,height:6,borderRadius:"50%",background:"#F59E0B",display:"flex",alignItems:"center",justifyContent:"center"}}>
        <span style={{fontSize:5,color:"#000",fontWeight:700}}>F</span>
      </div>
      <div style={{width:8,height:2,background:c2}}/>
    </div>
  );
}

// Colores por splitter
const SP_PALETTE = ["#2563EB","#F97316","#16A34A","#7C3AED","#DB2777","#0891B2","#CA8A04","#DC2626"];

// Diagrama SVG del splitter — dibujado con líneas, botón cerrar FUERA del svg
function DiagramaSplitter({sp, spIdx, fusiones, fibras, onCerrar}){
  const perdMap={"1x2":3.5,"1x4":7.3,"1x8":10.5,"1x16":13.9,"1x32":17.2};
  const numSal  = parseInt(sp.tipo.split("x")[1]);
  const spColor = SP_PALETTE[spIdx%SP_PALETTE.length];
  const spEnt   = fusiones.find(f=>f.tipo==="splitter_entrada"&&String(f.splitter_id)===String(sp.id));
  const spSals  = fusiones.filter(f=>f.tipo==="splitter_salida"&&String(f.splitter_id)===String(sp.id))
                          .sort((a,b)=>parseInt(a.splitter_salida_num)-parseInt(b.splitter_salida_num));
  const fibNom  = (id)=>fibras.find(f=>String(f.id)===String(id))?.nombre||"?";

  const HILO_H=32, LABEL_W=110, SP_W=100, SAL_W=140;
  const W=LABEL_W+80+SP_W+SAL_W+120;
  const MT=30, H=Math.max(numSal*HILO_H+MT*2+20, 160);
  const X_ENT_DOT=LABEL_W, X_F=LABEL_W+60;
  const X_SP_TIP=X_F+10, X_SP_BASE=X_SP_TIP+SP_W;
  const SP_TOP=MT, SP_BOT=MT+numSal*HILO_H, SP_MID=(SP_TOP+SP_BOT)/2;
  const X_SAL_DOT=X_SP_BASE+80, X_SAL_LABEL=X_SAL_DOT+10;

  return(
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.88)",zIndex:1000,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
      {/* BOTON CERRAR — FUERA del diagrama */}
      <div style={{marginBottom:12,display:"flex",alignItems:"center",gap:12}}>
        <button onClick={onCerrar} style={{background:"rgba(239,68,68,0.15)",color:"#F87171",border:"1px solid #F87171",borderRadius:6,padding:"6px 18px",cursor:"pointer",fontSize:12,fontWeight:600}}>
          ✕ Cerrar diagrama
        </button>
        <span style={{color:spColor,fontWeight:700,fontSize:13}}>
          Splitter {spIdx+1} — {sp.tipo} · {perdMap[sp.tipo]||"?"}dB
        </span>
      </div>

      {/* DIAGRAMA SVG */}
      <div style={{background:"#12121f",border:`2px solid ${spColor}`,borderRadius:8,padding:"16px",overflowX:"auto",overflowY:"auto",maxWidth:"95vw",maxHeight:"80vh"}}>
        <svg width={W} height={H} style={{display:"block",background:"#12121f"}}>

          {/* Triángulo splitter con color del splitter */}
          <polygon
            points={`${X_SP_TIP},${SP_MID} ${X_SP_BASE},${SP_TOP} ${X_SP_BASE},${SP_BOT}`}
            fill={`${spColor}22`} stroke={spColor} strokeWidth="2.5"
          />
          <text x={(X_SP_TIP+X_SP_BASE)/2+8} y={SP_MID-6} textAnchor="middle" fontSize="12" fill={spColor} fontWeight="700">{sp.tipo}</text>
          <text x={(X_SP_TIP+X_SP_BASE)/2+8} y={SP_MID+10} textAnchor="middle" fontSize="9" fill={spColor} opacity="0.7">{perdMap[sp.tipo]||"?"}dB</text>

          {/* ENTRADA al splitter */}
          {spEnt ? (()=>{
            const cE  = C[(parseInt(spEnt.hilo_entrada)-1)%12];
            const nE  = N[(parseInt(spEnt.hilo_entrada)-1)%12];
            const absE= (parseInt(spEnt.buffer_entrada)-1)*12+parseInt(spEnt.hilo_entrada);
            const fib = fibNom(spEnt.fibra_entrada_id);
            return(<>
              {/* Label entrada */}
              <text x={X_ENT_DOT-4} y={SP_MID-8} textAnchor="end" fontSize="9" fill={cE} fontWeight="700">H{absE} {nE}</text>
              <text x={X_ENT_DOT-4} y={SP_MID+4} textAnchor="end" fontSize="7" fill="#6B7280">{fib}</text>
              <text x={X_ENT_DOT-4} y={SP_MID+14} textAnchor="end" fontSize="7" fill="#FBBF24">← Entrada</text>
              {/* Punto entrada */}
              <circle cx={X_ENT_DOT} cy={SP_MID} r="6" fill={cE}/>
              {/* Línea entrada → F */}
              <line x1={X_ENT_DOT} y1={SP_MID} x2={X_F-8} y2={SP_MID} stroke={cE} strokeWidth="2"/>
              {/* Punto F */}
              <circle cx={X_F} cy={SP_MID} r="7" fill="#F59E0B"/>
              <text x={X_F} y={SP_MID+4} textAnchor="middle" fontSize="7" fill="#000" fontWeight="700">F</text>
              {/* Línea F → punta triángulo */}
              <line x1={X_F+7} y1={SP_MID} x2={X_SP_TIP} y2={SP_MID} stroke={cE} strokeWidth="2"/>
            </>);
          })() : (
            <text x={X_ENT_DOT-4} y={SP_MID+4} textAnchor="end" fontSize="9" fill="#4B5563">Sin entrada</text>
          )}

          {/* SALIDAS del splitter */}
          {Array.from({length:numSal},(_,i)=>{
            const sal   = spSals.find(s=>parseInt(s.splitter_salida_num)===i+1);
            const yS    = SP_TOP + i*(SP_BOT-SP_TOP)/(numSal-1||1);
            const cS    = sal ? C[(parseInt(sal.hilo_salida)-1)%12] : "#374151";
            const nS    = sal ? N[(parseInt(sal.hilo_salida)-1)%12] : "";
            const absS  = sal ? (parseInt(sal.buffer_salida)-1)*12+parseInt(sal.hilo_salida) : null;
            const dirS  = sal ? (sal.dir_salida||"adelante") : null;
            const fib   = sal ? fibNom(sal.fibra_salida_id) : "";
            return(<React.Fragment key={i}>
              {/* Punto base triángulo */}
              <circle cx={X_SP_BASE} cy={yS} r="5" fill={spColor}/>
              <text x={X_SP_BASE-2} y={yS+3} textAnchor="middle" fontSize="6" fill="#fff" fontWeight="700">{i+1}</text>
              {sal ? (<>
                {/* Línea salida → punto */}
                <line x1={X_SP_BASE} y1={yS} x2={X_SAL_DOT} y2={yS} stroke={cS} strokeWidth="1.5"
                  strokeDasharray={dirS==="devolver"?"5,3":"none"}/>
                {/* Punto salida */}
                <circle cx={X_SAL_DOT} cy={yS} r="5" fill={cS}/>
                {/* Labels salida */}
                <text x={X_SAL_LABEL} y={yS-4} fontSize="9" fill={cS} fontWeight="700">H{absS} {nS}</text>
                <text x={X_SAL_LABEL} y={yS+8} fontSize="7" fill="#6B7280">{fib}</text>
                <text x={X_SAL_LABEL} y={yS+18} fontSize="7" fill={dirS==="devolver"?"#FBBF24":"#34D399"}>
                  {dirS==="devolver"?"← Entrada":"→ Salida"}
                </text>
              </>) : (<>
                <line x1={X_SP_BASE} y1={yS} x2={X_SAL_DOT} y2={yS} stroke="#2a2a4a" strokeWidth="1" strokeDasharray="3,3"/>
                <text x={X_SAL_LABEL} y={yS+4} fontSize="8" fill="#374151">libre</text>
              </>)}
            </React.Fragment>);
          })}
        </svg>
      </div>
    </div>
  );
}

function TablaDeFibra({fibra, fusiones, splitters, fi, tieneSoloSalida, todasFibras}){
  const [filaExp, setFilaExp] = useState(null);
  const [verTipo, setVerTipo] = useState("todos");
  const [spDiagrama, setSpDiagrama] = useState(null);

  const bg    = FIB_BG[fi%8];
  const color = FIB_COLOR[fi%8];
  const totalH  = parseInt(fibra.tipo_hilos)||12;
  const numBufs = Math.ceil(totalH/12);
  const sp = splitters&&splitters.length>0?splitters[0]:null;

  // Construir filas
  const filas = [];
  for(let b=1;b<=numBufs;b++){
    const hilos = Math.min(12, totalH-(b-1)*12);
    const esDir = fusiones.some(f=>
      f.tipo==="buffer_completo"&&
      String(f.fibra_entrada_id)===String(fibra.id)&&
      parseInt(f.buffer_entrada)===b
    );
    if(esDir){
      filas.push({tipo:"dir", buf:b, hilos});
    } else {
      for(let h=1;h<=hilos;h++){
        const fuss = fusiones.filter(f=>{
          // splitter_entrada: aparece en la fibra de ENTRADA (hilo que alimenta el splitter)
          if(f.tipo==="splitter_entrada")
            return String(f.fibra_entrada_id)===String(fibra.id)&&parseInt(f.buffer_entrada)===b&&parseInt(f.hilo_entrada)===h;
          // splitter_salida: aparece en la fibra de SALIDA (hilo destino)
          if(f.tipo==="splitter_salida")
            return String(f.fibra_salida_id)===String(fibra.id)&&parseInt(f.buffer_salida)===b&&parseInt(f.hilo_salida)===h;
          // hilo_hilo y buffer_completo: aparece en ambas fibras según dirección
          return (String(f.fibra_entrada_id)===String(fibra.id)&&parseInt(f.buffer_entrada)===b&&parseInt(f.hilo_entrada)===h)||
                 (String(f.fibra_salida_id)===String(fibra.id)&&parseInt(f.buffer_salida)===b&&parseInt(f.hilo_salida)===h);
        });
        filas.push({tipo:"hilo", buf:b, hilo:h, fuss});
      }
    }
  }

  const filtradas = filas.filter(f=>{
    if(verTipo==="fusionados"&&f.tipo==="hilo"&&(!f.fuss||f.fuss.length===0)) return false;
    if(verTipo==="libres"&&f.tipo==="hilo"){
      // Libre si entrada O salida está libre
      const tieneEntrada = f.fuss&&f.fuss.some(fu=>
        (String(fu.fibra_entrada_id)===String(fibra.id)&&parseInt(fu.buffer_entrada)===f.buf&&parseInt(fu.hilo_entrada)===f.hilo)||
        (fu.tipo==="splitter_salida"&&fu.dir_salida==="devolver"&&String(fu.fibra_salida_id)===String(fibra.id)&&parseInt(fu.buffer_salida)===f.buf&&parseInt(fu.hilo_salida)===f.hilo)
      );
      const tieneSalida = f.fuss&&f.fuss.some(fu=>
        (String(fu.fibra_salida_id)===String(fibra.id)&&parseInt(fu.buffer_salida)===f.buf&&parseInt(fu.hilo_salida)===f.hilo&&fu.tipo!=="splitter_entrada"&&(fu.dir_salida||"adelante")==="adelante")||
        (fu.tipo==="splitter_salida"&&(fu.dir_salida||"adelante")==="adelante"&&String(fu.fibra_salida_id)===String(fibra.id)&&parseInt(fu.buffer_salida)===f.buf&&parseInt(fu.hilo_salida)===f.hilo)
      );
      if(tieneEntrada&&tieneSalida) return false; // ambos ocupados, no es libre
    }
    if(verTipo==="directos"&&f.tipo!=="dir") return false;
    return true;
  });

  const S={
    th:{padding:"2px 5px",fontSize:8,fontWeight:600,textAlign:"left",borderBottom:`1px solid ${color}44`,whiteSpace:"nowrap",background:`${color}18`},
    td:{padding:"1px 4px",borderBottom:`1px solid ${color}15`,verticalAlign:"middle",fontSize:9,whiteSpace:"nowrap"},
  };

  const numFus = fusiones.filter(f=>String(f.fibra_entrada_id)===String(fibra.id)||String(f.fibra_salida_id)===String(fibra.id)).length;

  // Columnas según tipo de fibra
  // tieneSoloSalida=true → no mostrar columna Entrada
  const colSpanDir = tieneSoloSalida ? 3 : 4; // B + (Ent) + F + Sal

  return(
    <div style={{border:`2px solid ${color}`,borderRadius:6,overflow:"hidden",marginBottom:8,background:bg}}>
      {/* Cabecera */}
      <div style={{background:`${color}22`,borderBottom:`2px solid ${color}`,padding:"3px 8px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
        <div style={{display:"flex",alignItems:"center",gap:6}}>
          <div style={{width:10,height:10,borderRadius:2,background:color}}/>
          <span style={{color,fontWeight:700,fontSize:10}}>{fibra.nombre}</span>
          <span style={{color:"#6B7280",fontSize:8}}>{fibra.tipo_hilos}h</span>
          {tieneSoloSalida
            ? <span style={{color:"#34D399",fontSize:7,background:"rgba(22,163,74,0.15)",padding:"1px 5px",borderRadius:4}}>↗ Solo salida (nace aquí)</span>
            : <span style={{color:"#FBBF24",fontSize:7,background:"rgba(234,179,8,0.1)",padding:"1px 5px",borderRadius:4}}>↔ Entrada + Salida</span>
          }
          <span style={{color:"#4B5563",fontSize:7}}>{numFus} fusiones</span>
        </div>
        <div style={{display:"flex",gap:3,flexWrap:"wrap"}}>
          {[["todos","Todo"],["fusionados","Con F"],["libres","Libres"],["directos","Dir"]].map(([v,l])=>(
            <button key={v} onClick={()=>setVerTipo(v)} style={{padding:"1px 5px",borderRadius:6,border:`1px solid ${color}55`,background:verTipo===v?color:"transparent",color:verTipo===v?"#fff":color,fontSize:7,cursor:"pointer"}}>{l}</button>
          ))}
          {splitters&&splitters.map((sp,si)=>{
            const spC=SP_PALETTE[si%SP_PALETTE.length];
            return(
              <button key={sp.id} onClick={()=>setSpDiagrama({sp,idx:si})} style={{padding:"1px 5px",borderRadius:6,border:`1px solid ${spC}`,background:`${spC}22`,color:spC,fontSize:7,cursor:"pointer",fontWeight:600}}>◀ SP{si+1} {sp.tipo}</button>
            );
          })}
        </div>
      </div>

      {/* Tabla */}
      <table style={{borderCollapse:"collapse",width:"100%",fontSize:9}}>
        <thead>
          <tr>
            <th style={{...S.th,width:18,color:color}}>B</th>
            <th style={{...S.th,width:65,color:"#9CA3AF"}}>Hilo</th>
            {!tieneSoloSalida&&<th style={{...S.th,width:110,color:"#FBBF24"}}>← Entrada</th>}
            <th style={{...S.th,width:55,color:"#F59E0B",textAlign:"center"}}>Fusión</th>
            <th style={{...S.th,color:"#34D399"}}>Salida →</th>
          </tr>
        </thead>
        <tbody>
          {filtradas.map((fila,idx)=>{
            const bColor=cBuf(fila.buf);

            if(fila.tipo==="dir"){
              const bLabel=`B${fila.buf}`;
              return(
                <tr key={`d${fila.buf}`} style={{background:`${bColor}12`}}>
                  {/* Celda B izquierda */}
                  <td style={{...S.td,color:bColor,fontWeight:700,fontSize:8,width:18}}>{bLabel}</td>
                  {/* Celda central con línea de lado a lado */}
                  <td colSpan={colSpanDir} style={{...S.td,padding:0}}>
                    <div style={{display:"flex",alignItems:"center",height:"100%",padding:"2px 0"}}>
                      <div style={{width:6,height:2,background:bColor,opacity:0.7}}/>
                      <div style={{flex:1,height:2,background:bColor,opacity:0.4,borderTop:`1px dashed ${bColor}`}}/>
                      <span style={{color:bColor,fontSize:8,fontWeight:600,padding:"0 6px",whiteSpace:"nowrap",flexShrink:0}}>
                        {bLabel} {nBuf(fila.buf)} — directo →→→
                      </span>
                      <div style={{flex:1,height:2,background:bColor,opacity:0.4,borderTop:`1px dashed ${bColor}`}}/>
                      <div style={{width:6,height:2,background:bColor,opacity:0.7}}/>
                    </div>
                  </td>
                  {/* Celda B derecha */}
                  <td style={{...S.td,color:bColor,fontWeight:700,fontSize:8,width:18,textAlign:"right"}}>{bLabel}</td>
                </tr>
              );
            }

            const {buf:b,hilo:h,fuss}=fila;
            const hAbs=absH(b,h), hColor=cH(b,h), hNom=nH(b,h);
            const tieneF=fuss&&fuss.length>0;
            const f=tieneF?fuss[0]:null;
            const key=`${b}-${h}`;
            const isExp=filaExp===key;

            let entNode=!tieneSoloSalida?<span style={{color:"#1e2a4a",fontSize:8}}>— libre —</span>:null;
            let salNode=<span style={{color:"#1e2a4a",fontSize:8}}>— libre —</span>;
            let fusNode=null;

            const SpTriangle = ({color})=>{
              const c=color||"#CA8A04";
              return <div style={{display:"inline-flex",alignItems:"center",gap:1}}><span style={{color:c,fontSize:9}}>◀</span><span style={{color:c,fontSize:6}}>SP</span></div>;
            };
            // Orden de splitters basado en mufa_splitters (splitters prop) no en fusiones
            const spIdsSorted = splitters.map(s=>String(s.id));
            const getSpC=(spId)=>SP_PALETTE[spIdsSorted.indexOf(String(spId))%SP_PALETTE.length]||"#CA8A04";
            const getSpNum=(spId)=>spIdsSorted.indexOf(String(spId))+1;

            // Procesar fusiones: separar por tipo
            // fusNode = icono de la fusión principal (entrada tiene prioridad)
            const fusEntrada = fuss.find(fu=>fu.tipo==="splitter_entrada");
            const fusSalidas = fuss.filter(fu=>fu.tipo==="splitter_salida");
            const fusHilos   = fuss.filter(fu=>fu.tipo==="hilo_hilo");

            // Columna Entrada
            if(fusEntrada&&!tieneSoloSalida){
              const spC=getSpC(fusEntrada.splitter_id);
              fusNode=<SpTriangle color={spC} num={getSpNum(fusEntrada.splitter_id)}/>;
              entNode=(
                <div style={{display:"flex",alignItems:"center",gap:2}}>
                  <Dot color={hColor} sz={6}/>
                  <span style={{color:hColor,fontSize:8}}>H{hAbs}</span>
                  <span style={{color:"#FBBF24",fontSize:7}}>← Ent</span>
                  <span style={{color:spC,fontSize:7}}>→◀SP</span>
                </div>
              );
            }

            // Columna Salida — salidas de splitter hacia adelante
            fusSalidas.forEach(fu=>{
              const cS2=cH(fu.buffer_salida,fu.hilo_salida);
              const absS2=absH(fu.buffer_salida,fu.hilo_salida);
              const nS2=nH(fu.buffer_salida,fu.hilo_salida);
              const dirS2=fu.dir_salida||"adelante";
              const spC=getSpC(fu.splitter_id);
              if(!fusNode) fusNode=<SpTriangle color={spC} num={getSpNum(fu.splitter_id)}/>;
              if(dirS2==="devolver"&&!tieneSoloSalida){
                entNode=(
                  <div style={{display:"flex",alignItems:"center",gap:2}}>
                    <SpTriangle color={spC} num={getSpNum(fu.splitter_id)}/>
                    <Dot color={cS2} sz={6}/>
                    <span style={{color:cS2,fontSize:8}}>H{absS2} {nS2}</span>
                    <span style={{color:"#FBBF24",fontSize:7}}>← Ent</span>
                  </div>
                );
              } else {
                fusNode=<SpTriangle color={spC} num={getSpNum(fu.splitter_id)}/>;
                salNode=(
                  <div style={{display:"flex",alignItems:"center",gap:2}}>
                    <SpTriangle color={spC} num={getSpNum(fu.splitter_id)}/>
                    <Dot color={cS2} sz={6}/>
                    <span style={{color:cS2,fontSize:8}}>H{absS2} {nS2}</span>
                    <span style={{color:"#34D399",fontSize:7}}>→</span>
                  </div>
                );
              }
            });

            // Fusiones hilo-hilo
            fusHilos.forEach(fu=>{
              const cE2=cH(fu.buffer_entrada,fu.hilo_entrada);
              const cS2=cH(fu.buffer_salida,fu.hilo_salida);
              const absS2=absH(fu.buffer_salida,fu.hilo_salida);
              const nS2=nH(fu.buffer_salida,fu.hilo_salida);
              const dirS2=fu.dir_salida||"adelante";
              const dirE2=fu.direccion||"devolver";
              fusNode=<FMark c1={cE2} c2={cS2}/>;

              // Detectar si la fusión cruza fibras
              const esCruce = String(fu.fibra_entrada_id)!==String(fu.fibra_salida_id);
              const fibSrcIdx = todasFibras.findIndex(fx=>String(fx.id)===String(fu.fibra_entrada_id));
              const fibDstIdx = todasFibras.findIndex(fx=>String(fx.id)===String(fu.fibra_salida_id));
              const fibSrcNom = todasFibras[fibSrcIdx]?.nombre||"";
              const fibDstNom = todasFibras[fibDstIdx]?.nombre||"";
              const fibSrcColor = FIB_COLOR[fibSrcIdx%8]||"#6B7280";
              const fibDstColor = FIB_COLOR[fibDstIdx%8]||"#6B7280";

              if(dirE2==="devolver"&&!tieneSoloSalida){
                entNode=(
                  <div style={{display:"flex",alignItems:"center",gap:2}}>
                    <Dot color={cE2} sz={6}/>
                    <span style={{color:cE2,fontSize:8}}>H{hAbs}</span>
                    <span style={{color:"#FBBF24",fontSize:7}}>← Ent</span>
                    {esCruce&&<span style={{color:fibSrcColor,fontSize:7,background:`${fibSrcColor}22`,padding:"0 3px",borderRadius:3,border:`1px solid ${fibSrcColor}55`}}>{fibSrcNom}</span>}
                  </div>
                );
              }
              if(dirS2==="adelante"){
                salNode=(
                  <div style={{display:"flex",alignItems:"center",gap:2}}>
                    <Dot color={cS2} sz={6}/>
                    <span style={{color:cS2,fontSize:8}}>H{absS2} {nS2}</span>
                    <span style={{color:"#34D399",fontSize:7}}>→</span>
                    {esCruce&&<span style={{color:fibDstColor,fontSize:7,background:`${fibDstColor}22`,padding:"0 3px",borderRadius:3,border:`1px solid ${fibDstColor}55`}}>{fibDstNom}</span>}
                  </div>
                );
              } else if(!tieneSoloSalida){
                entNode=(
                  <div style={{display:"flex",alignItems:"center",gap:2}}>
                    <Dot color={cS2} sz={6}/>
                    <span style={{color:cS2,fontSize:8}}>H{absS2} {nS2}</span>
                    <span style={{color:"#FBBF24",fontSize:7}}>← Ent</span>
                    {esCruce&&<span style={{color:fibDstColor,fontSize:7,background:`${fibDstColor}22`,padding:"0 3px",borderRadius:3,border:`1px solid ${fibDstColor}55`}}>{fibDstNom}</span>}
                  </div>
                );
              }
            });

            const rowBg = isExp?`${color}18`:tieneF?`${hColor}10`:idx%2===0?`${color}05`:"transparent";

            return(
              <React.Fragment key={key}>
                <tr onClick={()=>setFilaExp(isExp?null:key)} style={{background:rowBg,cursor:"pointer",borderLeft:tieneF?`2px solid ${hColor}`:"2px solid transparent"}}>
                  <td style={{...S.td,padding:"1px 3px"}}>
                    <div style={{width:7,height:7,borderRadius:1,background:bColor,opacity:0.8}}/>
                  </td>
                  <td style={S.td}>
                    <div style={{display:"flex",alignItems:"center",gap:3}}>
                      <Dot color={hColor} sz={tieneF?7:5}/>
                      <span style={{color:hColor,fontWeight:tieneF?600:400}}>H{hAbs}</span>
                      <span style={{color:"#374151",fontSize:7}}>{hNom}</span>
                    </div>
                  </td>
                  {!tieneSoloSalida&&<td style={S.td}>{entNode}</td>}
                  <td style={{...S.td,textAlign:"center"}}>{fusNode}</td>
                  <td style={S.td}>{salNode}</td>
                </tr>
                {isExp&&f&&(
                  <tr style={{background:`${color}10`}}>
                    <td colSpan={tieneSoloSalida?4:5} style={{...S.td,paddingLeft:16,color:"#6B7280",fontSize:7}}>
                      Tipo: <span style={{color:"#C4B5FD"}}>{f.tipo}</span>
                      {" · "}B{f.buffer_entrada} H{f.hilo_entrada} → B{f.buffer_salida} H{f.hilo_salida}
                      {" · dir: "}<span style={{color:"#FBBF24"}}>{f.direccion}</span>/<span style={{color:"#34D399"}}>{f.dir_salida||"adelante"}</span>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })}
        </tbody>
      </table>
      {spDiagrama&&<DiagramaSplitter sp={spDiagrama.sp} spIdx={spDiagrama.idx} fusiones={fusiones} fibras={todasFibras} onCerrar={()=>setSpDiagrama(null)}/>}
    </div>
  );
}

export default function DiagramaFibra({fibras, fusiones, splitters, fibrasEntrada, fibrasSalida, fibrasPaso}){
  if(!fibras||fibras.length===0) return <p style={{color:"#6B7280",fontSize:11}}>Sin fibras.</p>;

  // Determinar qué fibras tienen solo salida (nacen en la mufa)
  // fibras_salida = nacen en la mufa = solo salida
  // fibras_entrada y fibras_paso = tienen entrada y salida
  const soloSalidaIds = new Set((fibrasSalida||[]).map(f=>String(f.id)));

  const fibrasOrd=[...fibras].sort((a,b)=>parseInt(b.tipo_hilos)-parseInt(a.tipo_hilos));

  return(
    <div style={{background:"#12121f",borderRadius:6,padding:"6px"}}>
      <div style={{display:"flex",gap:4,marginBottom:6,flexWrap:"wrap",alignItems:"center"}}>
        <span style={{fontSize:8,color:"#6B7280"}}>{fibrasOrd.length} fibra(s):</span>
        {fibrasOrd.map((f,fi)=>{
          const soloSal=soloSalidaIds.has(String(f.id));
          return(
            <span key={f.id} style={{fontSize:8,color:FIB_COLOR[fi%8],background:`${FIB_COLOR[fi%8]}15`,padding:"1px 6px",borderRadius:8,border:`1px solid ${FIB_COLOR[fi%8]}44`}}>
              {f.nombre} {f.tipo_hilos}h {soloSal?"↗":"↔"}
            </span>
          );
        })}
      </div>
      {fibrasOrd.map((f,fi)=>(
        <TablaDeFibra
          key={f.id}
          fibra={f}
          fusiones={fusiones}
          splitters={splitters}
          fi={fi}
          tieneSoloSalida={soloSalidaIds.has(String(f.id))}
          todasFibras={fibrasOrd}
        />
      ))}
    </div>
  );
}
